var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompareimageLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 146,
    viewBox: "0 0 147 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41_188)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.82959,
    width: 145.434,
    height: 145.434,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9905 35.3653C18.9905 26.5287 26.1539 19.3653 34.9905 19.3653H93.7087V126.069H34.9905C26.1539 126.069 18.9905 118.905 18.9905 110.069V35.3653Z",
    fill: "#FEDF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7087 19.3653H112.103C120.939 19.3653 128.103 26.5287 128.103 35.3653V110.069C128.103 118.905 120.939 126.069 112.103 126.069H93.7087V19.3653Z",
    fill: "#77DD77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.365 83.1481V62.1252C110.365 52.8367 102.835 45.3069 93.5466 45.3069C84.2581 45.3069 76.7283 52.8367 76.7283 62.1252V83.1481C76.7283 92.4366 84.2581 99.9664 93.5466 99.9664C102.835 99.9664 110.365 92.4366 110.365 83.1481Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5466 99.9664C84.2581 99.9664 76.7283 92.4366 76.7283 83.1481V62.1252C76.7283 52.8367 84.2581 45.3069 93.5466 45.3069M93.5466 99.9664C102.835 99.9664 110.365 92.4366 110.365 83.1481V62.1252C110.365 52.8367 102.835 45.3069 93.5466 45.3069M93.5466 99.9664V156M93.5466 45.3069V-10.5662M89.3982 65.0608V81.3732L100.218 73.217L89.3982 65.0608Z",
    stroke: "#FF6347",
    strokeWidth: 4
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.82959,
    y: 2,
    width: 141.434,
    height: 141.434,
    rx: 30,
    stroke: "#FF6347",
    strokeWidth: 4,
    strokeDasharray: "14 8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41_188"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.82959,
    width: 145.434,
    height: 145.434,
    rx: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareimageLogo);
export default __webpack_public_path__ + "static/media/compareimage_logo.35d5f3256bf3d4f26f98e1eb5959bdbd.svg";
export { ForwardRef as ReactComponent };